import * as Yup from "yup";

const stringI18n = () =>
  Yup.object({
    de: Yup.string().required(),
    en: Yup.string().required(),
    fr: Yup.string().required(),
  });

const i18nWithUnits = () =>
  Yup.object({
    de: Yup.object({
      metric: Yup.string().required(),
      imperial: Yup.string().required(),
    }),
    en: Yup.object({
      metric: Yup.string().required(),
      imperial: Yup.string().required(),
    }),
    fr: Yup.object({
      metric: Yup.string().required(),
      imperial: Yup.string().required(),
    }),
  });

const correctionFactor = () => Yup.number().required();

const imageWithPivot = () =>
  Yup.object({
    url: Yup.string().required(),
    width: Yup.number().positive().required(),
    height: Yup.number().positive().required(),
    pivotTop: Yup.number().positive().required(),
    pivotLeft: Yup.number().positive().required(),
  });

const curve = () =>
  Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        x: Yup.number().required(),
        y: Yup.number().required(),
      })
    );

export const configurationSchema = Yup.object({
  version: Yup.string().required(),

  global: Yup.object({
    maxNumberOfRoofObstacles: Yup.number().positive().required(),

    maxNumberOfGroundObstacles: Yup.number().positive().required(),

    pressureStep: Yup.number().positive().required(),

    angleStep: Yup.number().positive().required(),

    angleMin: Yup.number().required(),

    angleMax: Yup.number().required(),

    monitorHeightMin: Yup.number().required(),

    monitorHeightMax: Yup.number().required(),

    monitorHeightStep: Yup.number().required(),

    footprint: Yup.object({
      correctionFactorMinX: correctionFactor(),
      correctionFactorMaxX: correctionFactor(),
      correctionFactorMinY: correctionFactor(),
      correctionFactorMaxY: correctionFactor(),
    }).required(),

    mediaTypes: Yup.object({
      water: Yup.object({
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      }).required(),
      foam: Yup.object({
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      }).required(),
    }),

    masterCurveForPositiveAngles: curve(),
    masterCurveForNegativeAngles: curve(),
  }),

  monitors: Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        id: Yup.string().min(1).required(),
        name: stringI18n(),
        description: i18nWithUnits(),
        image: imageWithPivot(),
        displayImageAboveNozzle: Yup.boolean(),
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
        flowRateStep: Yup.number().positive().required(),
        workingArea: Yup.array()
          .min(1)
          .required()
          .of(
            Yup.object({
              pressure: Yup.number().positive().required(),
              flowRateMinimum: Yup.number().positive().required(),
              flowRateMaximum: Yup.number().positive().required(),
            })
          ),
        compatibleNozzles: Yup.array()
          .min(1)
          .required()
          .of(
            Yup.object({
              id: Yup.string().required(),
              image: imageWithPivot(),
            })
          ),
      })
    ),

  nozzles: Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        id: Yup.string(),
        name: stringI18n(),
        description: i18nWithUnits(),
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      })
    ),

  flowRates: Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        volume: Yup.number().positive().required(),
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      })
    ),

  pressures: Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        pressure: Yup.number().positive().required(),
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      })
    ),

  angles: Yup.array()
    .min(1)
    .required()
    .of(
      Yup.object({
        angle: Yup.number().required(),
        correctionFactorX: correctionFactor(),
        correctionFactorY: correctionFactor(),
      })
    ),
});
